// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d534d3e0","455":"b682878c","488":"7cf3b721"}[chunkId] + ".chunk.js";
};